module.exports = __webpack_public_path__ + "img/Sec_XIII-XIV_Octoihul_de_la_Caransebes_BAR_350_f83.d760694e.jpg";